import type { IslandDetails } from "@monsterverse/island-types";

export type CameraData = { distance: number; pitch: number; yaw: number };

export type URLDataType = {
  location?: [number, number, number];
  camera?: CameraData;
  monsterConfig?: {
    body: string;
    color: string;
    eyes: string;
    mouth: string;
    feet: string;
    version: string;
  };
  balloon?: boolean;
  /**
   * Entity type to start the island with
   * Currently, supports "student" (default) or "teacher"
   */
  entityType?: string;
  /**
   * Island Id for the initial island the user should connect to when starting
   */
  islandId?: string;
  /**
   * Location where the user will spawn.
   */
  spawnPoint?: string;

  /**
   * Enables ghost/specator mode (fly camera, no monster)
   */
  ghostMode?: boolean;

  /**
   * Class year information passed from launcher to hub
   */
  classYear?: string;
};

// please update documentation if you make changes: https://www.notion.so/classdojo/Island-Query-Parameters-1895ed942e8a80f49a4ecf1f3bfad93f
export function parseURL(): URLDataType | undefined {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const data = urlSearchParams.get("data");
  if (data) {
    try {
      const decodedData: URLDataType & { classId?: string; island?: IslandDetails } = JSON.parse(decodeURLString(data));
      const parsedData = {
        ...decodedData,
        // if islandId is present, it prevails over classId
        // Old mobile clients will send classId.
        islandId: decodedData.islandId || decodedData.island?.id || decodedData.classId,
      };
      delete parsedData.classId; // remove classId if present
      return parsedData;
    } catch {}
  }
}

export function getNavigationTransitionSource() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const source = urlSearchParams.get("source");
  return source || "student_app";
}

export function encodeURLString(str: string) {
  // Replace base64 non-url compatible chars (base64url encoding)
  // https://www.rfc-editor.org/rfc/rfc4648#page-7
  return btoa(encodeURIComponent(str)).replace(/\+/g, "-").replace(/\//g, "_");
}

export function decodeURLString(str: string) {
  // Replace non-url compatible chars with base64 standard chars (base64url encoding)
  // https://www.rfc-editor.org/rfc/rfc4648#page-7
  return decodeURIComponent(atob(str.replace(/-/g, "+").replace(/_/g, "/")));
}
